export const LOAD_OFFER_PARTNER_SUCCEEDED = "LOAD_OFFER_PARTNER_SUCCEEDED";
export const LOAD_OFFER_PARTNER_BY_ID_STARTED = "LOAD_OFFER_PARTNER_BY_ID_STARTED";
export const LOAD_OFFER_PARTNER_BY_ID_SUCCEEDED = "LOAD_OFFER_PARTNER_BY_ID_SUCCEEDED";
export const LOAD_OFFER_PARTNER_BY_ID_FAILED = "LOAD_OFFER_PARTNER_BY_ID_FAILED";

export const LOAD_OFFER_ASSOCIATED_PARTNERS_SUCCEEDED = "LOAD_OFFER_ASSOCIATED_PARTNERS_SUCCEEDED";

export const TOGGLE_OFFER_PARTNER_FORM_CARD = "TOGGLE_OFFER_PARTNER_FORM_CARD";

export const SAVE_OFFER_PARTNER_STARTED = "SAVE_OFFER_PARTNER_STARTED";
export const SAVE_OFFER_PARTNER_SUCCEEDED = "SAVE_OFFER_PARTNER_SUCCEEDED";
export const SAVE_OFFER_PARTNER_FAILED = "SAVE_OFFER_PARTNER_FAILED";

export const SAVE_OFFER_PARTNER_ADDRESSES_STARTED = "SAVE_OFFER_PARTNER_ADDRESSES_STARTED";
export const SAVE_OFFER_PARTNER_ADDRESSES_SUCCEEDED = "SAVE_OFFER_PARTNER_ADDRESSES_SUCCEEDED";
export const SAVE_OFFER_PARTNER_ADDRESSES_FAILED = "SAVE_OFFER_PARTNER_ADDRESSES_FAILED";
export const REFRESH_PARTNER_ADDRESSES_STARTED = "REFRESH_PARTNER_ADDRESSES_STARTED";
export const REFRESH_PARTNER_ADDRESSES_FINISHED = "REFRESH_PARTNER_ADDRESSES_FINISHED";
export const REFRESH_PARTNER_ADDRESSES_IN_PROGRESS = "REFRESH_PARTNER_ADDRESSES_IN_PROGRESS";

export const LOAD_CLIENT_BY_ID_SUCCEEDED = "LOAD_CLIENT_BY_ID_SUCCEEDED";
export const LOAD_CLIENT_FROM_STARBYTE_SUCCEEDED = "LOAD_CLIENT_FROM_STARBYTE_SUCCEEDED";

export const LOAD_NATIONALITY_ID_BY_UNIQUE_ID_SUCCEDEED = "LOAD_NATIONALITY_ID_BY_UNIQUE_ID_SUCCEDEED";

export const LOAD_CLIENT_BY_CARD_STARTED = "LOAD_CLIENT_BY_CARD_STARTED";
export const LOAD_CLIENT_BY_CARD_SUCCEEDED = "LOAD_CLIENT_BY_CARD_SUCCEEDED";
export const LOAD_CLIENT_BY_CARD_FAILED = "LOAD_CLIENT_BY_CARD_FAILED";

export const LOAD_PARTNER_TYPES_SUCCEEDED = "LOAD_PARTNER_TYPES_SUCCEEDED";
export const LOAD_ID_TYPES_SUCCEEDED = "LOAD_ID_TYPES_SUCCEEDED";
export const LOAD_COUNTRIES_SUCCEEDED = "LOAD_COUNTRIES_SUCCEEDED";
export const LOAD_CITIZENSHIPS_SUCCEEDED = "LOAD_CITIZENSHIPS_SUCCEEDED";
export const LOAD_RELATIONS_SUCCEEDED = "LOAD_RELATIONS_SUCCEEDED";

export const LOAD_COUNTIES_STARTED = "LOAD_COUNTIES_STARTED";
export const LOAD_COUNTIES_SUCCEEDED = "LOAD_COUNTIES_SUCCEEDED";

export const LOAD_GDPR_SUCCEEDED = "LOAD_GDPR_SUCCEEDED";
export const LOAD_CITIES_SUCCEEDED = "LOAD_CITIES_SUCCEEDED";
export const LOAD_PARTNER_ROLES_SUCCEEDED = "LOAD_PARTNER_ROLES_SUCCEEDED";

export const LOAD_DEFAULT_PARTNER_ADDRESS_SUCCEEDED = "LOAD_DEFAULT_PARTNER_ADDRESS_SUCCEEDED";
export const LOAD_DEFAULT_PARTNER_ADDRESS_STARTED = "LOAD_DEFAULT_PARTNER_ADDRESS_STARTED";

export const SET_DEFAULT_ADDRESS_ON_CLIENT = "SET_DEFAULT_ADDRESS_ON_CLIENT";
export const SET_DEFAULT_ADDRESS_ON_OFFER_CLIENT = "SET_DEFAULT_ADDRESS_ON_OFFER_CLIENT";

export const FINISH_PARTNER_QUERY = "FINISH_PARTNER_QUERY";

export const SET_BIRTH_DATE_ON_CLIENT = "SET_BIRTH_DATE_ON_CLIENT";
export const SET_PARTNER_ROLE_ON_CLIENT = "SET_PARTNER_ROLE_ON_CLIENT";

export const PRINTING_GDPR_STARTED = "PRINTING_GDPR_STARTED";
export const PRINTING_GDPR_SUCCEEDED = "PRINTING_GDPR_SUCCEEDED";
export const PRINTING_GDPR_FAILED = "PRINTING_GDPR_FAILED";
export const PRINTING_PARTNER_GDPR_STARTED = "PRINTING_PARTNER_GDPR_STARTED";
export const PRINTING_PARTNER_GDPR_SUCCEEDED = "PRINTING_PARTNER_GDPR_SUCCEEDED";

export const DELETE_OFFER_ASSOCIATED_PARTNER_STARTED = "DELETE_OFFER_ASSOCIATED_PARTNER_STARTED";
export const DELETE_OFFER_ASSOCIATED_PARTNER_FAILED = "DELETE_OFFER_ASSOCIATED_PARTNER_FAILED";

export const DELETE_OFFER_DOCUMENT_PARTNER_STARTED = "DELETE_OFFER_DOCUMENT_PARTNER_STARTED";
export const DELETE_OFFER_DOCUMENT_PARTNER_FAILED = "DELETE_OFFER_DOCUMENT_PARTNER_FAILED";

export const CANCEL_OFFER_CLIENT_CHANGES = "CANCEL_OFFER_CLIENT_CHANGES";

export const GET_COMPANY_INFO_SUCCEEDED = "GET_COMPANY_INFO_SUCCEEDED";
export const LOAD_PARTNER_FROM_QUERY = "LOAD_PARTNER_FROM_QUERY";
export const LOAD_PARTNER_FROM_QUERY_PROGRESS_STARTED = "LOAD_PARTNER_FROM_QUERY_PROGRESS_STARTED";
export const LOAD_PARTNER_FROM_QUERY_PROGRESS_FAILED = "LOAD_PARTNER_FROM_QUERY_PROGRESS_FAILED";

export const LOAD_PF_PARTNERS_SUCCEEDED = "LOAD_PF_PARTNERS_SUCCEEDED";
export const LOAD_PF_PARTNERS_STARTED = "LOAD_PF_PARTNERS_STARTED";
export const LOAD_PF_PARTNERS_FAILED = "LOAD_PF_PARTNERS_FAILED";

export const LOAD_PJ_PARTNERS_SUCCEEDED = "LOAD_PJ_PARTNERS_SUCCEEDED";
export const LOAD_PJ_PARTNERS_STARTED = "LOAD_PJ_PARTNERS_STARTED";
export const LOAD_PJ_PARTNERS_FAILED = "LOAD_PJ_PARTNERS_STARTED";

export const LOAD_PFA_PARTNERS_SUCCEEDED = "LOAD_PFA_PARTNERS_SUCCEEDED";
export const LOAD_PFA_PARTNERS_STARTED = "LOAD_PFA_PARTNERS_STARTED";
export const LOAD_PFA_PARTNERS_FAILED = "LOAD_PFA_PARTNERS_STARTED";

export const LOAD_PARTNER_HIERARCHY_SUCCEEDED = "LOAD_PARTNER_HIERARCHY_SUCCEEDED";
export const SAVE_ADDED_HIERARCHY_PARTNERS_STARTED = "SAVE_ADDED_HIERARCHY_PARTNERS_STARTED";
export const SAVE_ADDED_HIERARCHY_PARTNERS_SUCCEEDED = "SAVE_ADDED_HIERARCHY_PARTNERS_SUCCEEDED";
export const SAVE_ADDED_HIERARCHY_PARTNERS_FAILED = "SAVE_ADDED_HIERARCHY_PARTNERS_FAILED";

export const LOAD_CLIENT_ADDRESSES_STARTED = "LOAD_CLIENT_ADDRESSES_STARTED";
export const LOAD_CLIENT_ADDRESSES_SUCCEEDED = "LOAD_CLIENT_ADDRESSES_SUCCEEDED";
export const LOAD_CLIENT_ADDRESSES_FAILED = "LOAD_CLIENT_ADDRESSES_FAILED";

export const LOAD_OCR_FILE_EXTENSIONS_SUCCEDED = "LOAD_OCR_FILE_EXTENSIONS_SUCCEDED";

//server events
export * from "./eventTypes";
